import emotionStyled from '@emotion/styled';

export const CheckoutHeading = emotionStyled.h1`
  font-size: 2.3rem;
  font-weight: normal;
  padding: 20px 0 20px 0;
  border-bottom: 1px solid #e5e5e5;
`;
